<template>
  <v-alert
      v-test="{ error: '' }"
      class="text-center"
      :value="!!generalError"
      type="error"
      :dark="$vuetify.theme.dark">
    <p>
      {{ generalError.message }}
    </p>
    <div v-if="hasInvalid">
      <ul
          v-for="(invDescription, key) in generalError.invalid"
          :key="`invalid-${key}`">
        <li
            v-for="(item, index) in invDescription"
            :key="`invDescription-${index}`">
          {{ item }}
        </li>
      </ul>
    </div>
    <div v-if="!!generalError.description">
      <p>
        {{ generalError.description }}
      </p>
    </div>
  </v-alert>
</template>

<style scoped>
  ul {
    list-style-type: none;
  }
</style>

<script>

  export default {
    computed: {
      hasInvalid () {
        const err = this.generalError
        return (err && err.invalid)
      }
    },
    beforeDestroy: function () {
      // console.log('destroyed')
      this.hideErrorAction()
    }
  }
</script>
